// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__T8VnW","header":"MessagesList_header__kt7xg","chat":"MessagesList_chat__1QuAV"};